function updateCustomMessage() {
  const msgDiv = document.getElementById("custom-message");
  const quantityInput = document.querySelector('input[name="quantity"]');

  const btnUp = document.querySelector('.quantity-button.quantity-up');
  const btnDown = document.querySelector('.quantity-button.quantity-down');

  const unitDiv = document.getElementById("product-unit");

  //alert(parseInt(unitDiv.dataset.unitPerQuantity) || 1);

  //const unit = 77;

  if (msgDiv && quantityInput) {
    const updateMessage = () => {
      const unit = parseInt(unitDiv.dataset.unitPerQuantity) || 1;
      const qty = parseInt(quantityInput.value) || 1;
      msgDiv.textContent = `You will receive ${qty * unit} units.`;
      msgDiv.style.color = "green";
      //alert("✅ custom-quantity-message div updated");
    };

    updateMessage();

    btnUp?.addEventListener("click", updateMessage);
    btnDown?.addEventListener("click", updateMessage);
    
  }
}

function updateCustomMessages() {
  
  const items = document.querySelectorAll('.media-link');

  items.forEach(item => {
    //alert("✅ custom-quantity-message div updated");
    const line = item.getAttribute('data-line');
    const msgDiv = item.querySelector('.custom-message2');
    //const unitDiv = item.querySelector(`#product-unit-${line}`);
    const unitDiv = item.querySelector('.product-unit');

    const input = item.querySelector(`input[name="updates[]"][data-line="${line}"]`);
    const btnUp = item.querySelector('.quantity-button.quantity-up');
    const btnDown = item.querySelector('.quantity-button.quantity-down');

    if (!msgDiv || !unitDiv || !input) return;

    const updateMsg = () => {
      const unit = parseInt(unitDiv.dataset.unitPerQuantity || "1", 10);
      const qty = parseInt(input.value || "1", 10);
      msgDiv.textContent = `You will receive ${qty * unit} units.`;
      msgDiv.style.color = "green";
    };

    // Initial call
    updateMsg();

    // Update on button click (with delay due to AJAX handling)
    btnUp?.addEventListener('click', updateMsg);
    btnDown?.addEventListener('click', updateMsg);

    // Update on manual change
    input.addEventListener('change', updateMsg);
  });
}


// Run initially after delay to let Shopify DOM load
setTimeout(updateCustomMessage, 1000);
setTimeout(updateCustomMessages, 2000);




document.addEventListener("change", function (e) {
  //if (e.target.matches('select[name^="options["], input[type="radio"][name^="options["]')) {
    //alert("going to update");
    setTimeout(updateCustomMessage, 1000); // wait for DOM update
    setTimeout(updateCustomMessages, 2000); // wait for DOM update
  //}
});

document.addEventListener("click", function (e) {
  //if (e.target.matches('select[name^="options["], input[type="radio"][name^="options["]')) {
    //alert("going to update");
    setTimeout(updateCustomMessage, 1000); // wait for DOM update
    setTimeout(updateCustomMessages, 2000); // wait for DOM update
  //}
});

